'use client';

import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from '@src/lib/utils';

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-4', className)}
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  indicatorClassName,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  indicatorClassName?: string;
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'h-[18px] w-[18px] rounded-full border transition-all border-[#C9C9C9] data-[state=checked]:border-gray-1000',
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <div
          className={cn(
            'h-[10px] w-[10px] rounded-full bg-gray-1000',
            indicatorClassName
          )}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
